import _createClass from '@babel/runtime/helpers/esm/createClass';

/* eslint-disable */
import FunctionValidator from './FunctionValidator';

var FunctionParameters = /*#__PURE__*/function () {
  function FunctionParameters(parameter) {
    this._displayType = parameter.displayType;
    this._optionalValues = parameter.optionalValues;
    this._validators = parameter.validators.map(function (validator) {
      return new FunctionValidator(validator);
    });
    this._name = parameter.name;
    this._description = parameter.description;
    this._type = parameter.type;
    this._mandatory = parameter.mandatory;
    this._defaultValue = parameter.defaultValue;
  }

  var _proto = FunctionParameters.prototype;

  _proto.validateValue = function validateValue(value) {
    var _this = this;

    var validationErrors = [];
    var isValid = true;

    if ((!value || value === '') && this._mandatory) {
      return {
        isValid: false,
        validationErrors: ['Mandatory field is empty']
      };
    }

    this._validators.forEach(function (validator) {
      switch (validator.name) {
        case 'null':
          if (value == null && _this._mandatory) {
            isValid = false;
            validationErrors.push('null');
          }

          break;

        case 'nan':
          if (isNaN(value)) {
            isValid = false;
            validationErrors.push('nan');
          }

          break;

        case 'range':
          if (!(parseInt(value, 10) > validator.parameters.lowerRange && parseInt(value, 10) < validator.parameters.upperRange)) {
            isValid = false;
            validationErrors.push('range');
          }

          break;

        case 'greater-than-equals':
          if (parseInt(value, 10) < validator.parameters.limit) {
            isValid = false;
            validationErrors.push('greater-than-equals');
          }

          break;

        case 'empty-string':
          if (value === '') {
            isValid = false;
            validationErrors.push('empty-string');
          }

          break;

        default:
      }
    }); // TODO -gabpac

    /*
    null is not valid
    NaN is not valid
    value is out of range (upper limit or lower limit)
    greater-than-equals - value is not above the mininum
    empty-string - string should not be empty
    ? - want to add something over it?
     Dropdowns need defaults (of type list_single_selection)
    What is mandatory
    Add each funciton to a function group
     */


    return {
      isValid: isValid,
      validationErrors: validationErrors
    };
  };

  _createClass(FunctionParameters, [{
    key: 'displayType',
    get: function get() {
      return this._displayType;
    }
  }, {
    key: 'optionalValues',
    get: function get() {
      return this._optionalValues;
    },
    set: function set(val) {
      this._optionalValues = val;
    }
  }, {
    key: 'validators',
    get: function get() {
      return this._validators;
    },
    set: function set(val) {
      this._validators = val;
    }
  }, {
    key: 'name',
    get: function get() {
      return this._name;
    },
    set: function set(val) {
      this._name = val;
    }
  }, {
    key: 'description',
    get: function get() {
      return this._description;
    },
    set: function set(val) {
      this._description = val;
    }
  }, {
    key: 'type',
    get: function get() {
      return this._type;
    },
    set: function set(val) {
      this._type = val;
    }
  }, {
    key: 'mandatory',
    get: function get() {
      return this._mandatory;
    },
    set: function set(val) {
      this._mandatory = val;
    }
  }, {
    key: 'defaultValue',
    get: function get() {
      return this._defaultValue;
    },
    set: function set(val) {
      this._defaultValue = val;
    }
  }, {
    key: 'displayName',
    set: function set(val) {
      this._displayType = val;
    }
  }]);

  return FunctionParameters;
}();

export { FunctionParameters as default };